module.exports = __webpack_public_path__ + "assets/hoppa3.jpg?4c1fb8ab6820090fe593caee7ac7fcec";